"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useSyncExternalStore } from "react";
import { cn } from "@/lib/utils";
interface RippleButtonProps {
  children: React.ReactNode;
  href?: string;
  target?: string;
  rel?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

// Theme detection hook (mirrors InteractiveHoverButton pattern)
const subscribe = (callback: () => void) => {
  if (typeof document === "undefined") return () => {};
  const observer = new MutationObserver(callback);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"]
  });
  return () => observer.disconnect();
};
const getSnapshot = () => {
  if (typeof document === "undefined") return "brutalist";
  const cl = document.documentElement.classList;
  if (cl.contains("theme-neumorphic")) return "neumorphic";
  return "brutalist";
};
const getServerSnapshot = () => "brutalist";
export function RippleButton(t0) {
  const $ = _c(36);
  const {
    children,
    href,
    target,
    rel,
    className,
    onClick
  } = t0;
  const theme = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  const isNeumorphic = theme === "neumorphic";
  const circleColor = isNeumorphic ? "#4b5563" : "#ffffff";
  const hoverTextColor = isNeumorphic ? "#ffffff" : "#000000";
  let t1;
  if ($[0] !== className) {
    t1 = cn("ripple-btn group relative overflow-hidden select-none", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClick || $[3] !== t1) {
    t2 = {
      onClick,
      className: t1
    };
    $[2] = onClick;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const sharedProps = t2;
  let t3;
  if ($[5] !== circleColor) {
    t3 = <span className="ripple-circle circle1" style={{
      backgroundColor: circleColor
    }} />;
    $[5] = circleColor;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== circleColor) {
    t4 = <span className="ripple-circle circle2" style={{
      backgroundColor: circleColor
    }} />;
    $[7] = circleColor;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== circleColor) {
    t5 = <span className="ripple-circle circle3" style={{
      backgroundColor: circleColor
    }} />;
    $[9] = circleColor;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== circleColor) {
    t6 = <span className="ripple-circle circle4" style={{
      backgroundColor: circleColor
    }} />;
    $[11] = circleColor;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== circleColor) {
    t7 = <span className="ripple-circle circle5" style={{
      backgroundColor: circleColor
    }} />;
    $[13] = circleColor;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== children) {
    t8 = <span className="ripple-text">{children}</span>;
    $[15] = children;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = `
        .ripple-btn {
          position: relative;
          overflow: hidden;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        /* Target all circle spans */
        .ripple-btn > .ripple-circle {
          position: absolute;
          left: 50%;
          top: 50%;
          height: 30px;
          width: 30px;
          border-radius: 50%;
          transition: transform 0.6s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.6s ease;
          pointer-events: none;
          z-index: 1;
          opacity: 0;
          will-change: transform, opacity; /* GPU acceleration to prevent UI lag */
        }

        .ripple-btn > .ripple-text {
          position: relative;
          z-index: 10;
          transition: color 0.3s ease;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: inherit;
        }

        /* Initial offset positioning and scale(0) for circles */
        .ripple-btn > .circle1 {
          transform: translate(-3.3em, -4em) scale(0);
        }

        .ripple-btn > .circle2 {
          transform: translate(-6em, 1.3em) scale(0);
        }

        .ripple-btn > .circle3 {
          transform: translate(-0.2em, 1.8em) scale(0);
        }

        .ripple-btn > .circle4 {
          transform: translate(3.5em, 1.4em) scale(0);
        }

        .ripple-btn > .circle5 {
          transform: translate(3.5em, -3.8em) scale(0);
        }

        /* Hover effect wrapped in hover media query to prevent sticky states on mobile */
        @media (hover: hover) {
          .ripple-btn:hover > .ripple-circle {
            transform: translate(-50%, -50%) scale(5.3);
            opacity: 0.95;
            transition: transform 1.2s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.4s ease;
          }

          .ripple-btn:hover > .ripple-text {
            color: ${hoverTextColor} !important;
          }
        }

        /* Touch support active states for mobile compatibility */
        @media (hover: none) {
          .ripple-btn:active > .ripple-circle {
            transform: translate(-50%, -50%) scale(5.3);
            opacity: 0.95;
            transition: transform 1.2s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.4s ease;
          }
          .ripple-btn:active > .ripple-text {
            color: ${hoverTextColor} !important;
          }
        }
      `;
  let t10;
  if ($[17] !== t9) {
    t10 = <style>{t9}</style>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t11 = <>{t3}{t4}{t5}{t6}{t7}{t8}{t10}</>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const inner = t11;
  if (href) {
    const t12 = sharedProps as React.ComponentPropsWithoutRef<"a">;
    let t13;
    if ($[27] !== href || $[28] !== inner || $[29] !== rel || $[30] !== t12 || $[31] !== target) {
      t13 = <a {...t12} href={href} target={target} rel={rel}>{inner}</a>;
      $[27] = href;
      $[28] = inner;
      $[29] = rel;
      $[30] = t12;
      $[31] = target;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    return t13;
  }
  const t12 = sharedProps as React.ComponentPropsWithoutRef<"button">;
  let t13;
  if ($[33] !== inner || $[34] !== t12) {
    t13 = <button {...t12}>{inner}</button>;
    $[33] = inner;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
}
export default RippleButton;